import { render, staticRenderFns } from "./battery.vue?vue&type=template&id=2736599d&scoped=true&"
import script from "./battery.vue?vue&type=script&lang=js&"
export * from "./battery.vue?vue&type=script&lang=js&"
import style0 from "./battery.vue?vue&type=style&index=0&id=2736599d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2736599d",
  null
  
)

export default component.exports